import { render, staticRenderFns } from "./Pifs.vue?vue&type=template&id=3bb047c5&scoped=true&"
import script from "./Pifs.vue?vue&type=script&lang=js&"
export * from "./Pifs.vue?vue&type=script&lang=js&"
import style0 from "./Pifs.vue?vue&type=style&index=0&id=3bb047c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb047c5",
  null
  
)

export default component.exports